/**
 * @generated SignedSource<<b8cd709e5d7592fd78f067cc07536c95>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateAssetInput = {
  clientMutationId?: string | null;
  elementId?: string | null;
  url: string;
};
export type ActiveElementContent_CreateAsset_Mutation$variables = {
  input: CreateAssetInput;
};
export type ActiveElementContent_CreateAsset_Mutation$data = {
  readonly createAsset: {
    readonly asset: {
      readonly id: string;
    } | null;
  } | null;
};
export type ActiveElementContent_CreateAsset_Mutation = {
  response: ActiveElementContent_CreateAsset_Mutation$data;
  variables: ActiveElementContent_CreateAsset_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateAssetPayload",
    "kind": "LinkedField",
    "name": "createAsset",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AssetNode",
        "kind": "LinkedField",
        "name": "asset",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ActiveElementContent_CreateAsset_Mutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ActiveElementContent_CreateAsset_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "25ae4b2ba9468e0a4f2d0989147c16b3",
    "id": null,
    "metadata": {},
    "name": "ActiveElementContent_CreateAsset_Mutation",
    "operationKind": "mutation",
    "text": "mutation ActiveElementContent_CreateAsset_Mutation(\n  $input: CreateAssetInput!\n) {\n  createAsset(input: $input) {\n    asset {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d1752ade4897e897c1d425a366b37cf6";

export default node;
